import React, { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Tabs, Tab, Form, Table, Pagination, Offcanvas } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { SlCalender } from "react-icons/sl";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import Notauthorized from "../../components/Not-authorized/notauthorized";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import { formatDateTime, formatDateDMY, formatTime } from "../../utils/Helper";
import MomListFilter from "./MomListFilter";
import Paginator from "../../components/common/Pagination";
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  format,
  isSameDay,
  isSameMonth,
  parseISO,
} from 'date-fns';
import '../../assets/css/Calendar.css';
import { capitalizeFirstLetter } from "../../utils/Helper";
import { RiDownloadCloudFill } from "react-icons/ri";

const MomList = () => {
  const [activeTab, setActiveTab] = useState("listView");
  const permissionscontext = useMenuPermissions("/admin/mom-list");
  const [momList, setMomList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const limit = 10;
  const navigate = useNavigate();
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [eventList, setEventList] = useState([]);
  const [download, setDownload] = useState(false);
  const [selectedRange, setSelectedRange] = useState("");
  const goToDetails = (id) => {
    window.open(`/admin/mom-details/${id}`, '_blank');
  }

  const renderHeader = () => {
    const dateFormat = 'MMMM';
    return (
      <div className="header row flex-middle">
        <div className="col col-start">
          <div className="icon" onClick={prevMonth}>
            <span className="material-icons"><img
              src="/images/left_arrow.svg"
              className="img-fluid ms-2"
              alt="Sort"
            /></span>
          </div>
        </div>
        <div className="col col-center">
          <span>{format(currentMonth, dateFormat)}</span>
        </div>
        <div className="col col-end" onClick={nextMonth}>
          <div className="icon">
            <span className="material-icons"><img
              src="/images/right_arrow.svg"
              className="img-fluid ms-2"
              alt="Sort"
            /></span>
          </div>
        </div>
      </div>
    );
  };

  const renderDays = () => {
    const dateFormat = 'EEEE';
    const days = [];
    let startDate = startOfWeek(currentMonth);
    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col col-center" key={i}>
          {format(addDays(startDate, i), dateFormat)}
        </div>
      );
    }
    return <div className="days row">{days}</div>;
  };

  const renderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart);
    const endDate = endOfWeek(monthEnd);
    const dateFormat = 'd';
    const rows = [];
    let days = [];
    let day = startDate;
    let formattedDate = '';
    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = format(day, dateFormat);
        const cloneDay = day;
        const dailyEvents = eventList.filter((e) => isSameDay(e.date, cloneDay));
        days.push(
          <div
            className={`col cell ${!isSameMonth(day, monthStart)
              ? 'disabled'
              : isSameDay(day, new Date())
                ? 'selected'
                : ''
              }`}
            key={day}
          >
            <span className="number">{formattedDate}</span>
            {dailyEvents.map((event, index) => (
              <span className="event " key={index} onClick={() => goToDetails(event.mom_id)}
                title={`${event.agenda}\n${event.date_time}`} >
                <b>{event.agenda}</b>
              </span>
            ))}
          </div>
        );
        day = addDays(day, 1);
      }
      rows.push(
        <div className="row" key={day}>
          {days}
        </div>
      );
      days = [];
    }
    return <div className="body">{rows}</div>;
  };

  const nextMonth = () => {
    setCurrentMonth(addDays(currentMonth, 31));
  };

  const prevMonth = () => {
    setCurrentMonth(addDays(currentMonth, -31));
  };

  useEffect(() => {
    fetchEventList();
  }, []);

  useEffect(() => {
    fetchMomList(currentPage, filters);
  }, [currentPage, filters]);

  const fetchMomList = async (page = 1, filters) => {
    const params = {
      ...filters,
      offset: (page - 1) * limit,
      limit: limit,
    };

    const queryString = Object.entries(params)
      .filter(
        ([_, value]) => value !== "" && value !== undefined && value !== null
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");

    try {
      const response = await APIServices.get(
        `/admin/mom/list?${queryString}`,
        headers
      );
      if (response?.status === 200) {
        setMomList(response?.data?.list || []);
        setCount(response?.data?.count);
        const totalItems = response?.data?.count || 0;
        setTotalCount(Math.ceil(totalItems / limit));
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setMomList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setMomList([]);
      setTotalCount(0);
    }
  };

  const fetchEventList = async () => {

    try {
      const response = await APIServices.get(
        `/admin/mom/calendar_event`,
        headers
      );
      if (response?.status === 200) {
        let events = response?.data?.list;
        const updatedNewEvent = events.map(event => ({
          ...event,
          date: parseISO(event.date),
        }));
        setEventList(updatedNewEvent);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setEventList([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setEventList([]);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDownload = async()=>{
    setDownload(true);
    const params = {
        ...filters,
        offset: 0,
        limit: 10000,
        downloadFileName:"mom_list"
    };

    const queryString = Object.entries(params)
        .filter(
            ([_, value]) => value !== "" && value !== undefined && value !== null
        )
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

    try {
        const response = await APIServices.get(
            `/admin/mis_report/download?${queryString}`,
            headers
        );
        if (response?.status === 200) {
            if(response?.data?.excelFileUrl ){
                window.open(response?.data?.excelFileUrl)
            }
        } else if (response?.status === 401) {
            logout();
            navigate("/");
        }
    } catch (error) {
        console.error("Error download excel:", error);
    }finally{
        setDownload(false)
    }

}

  return (
    <>
      {permissionscontext.view ? (
        <>
          <div className="momList_inner todo_list_inner">
            <div className="mom_header d-flex align-items-center justify-content-between mb-3">
              <h1 className="font_blue_18 font-600">{`Minutes of Meeting List (${count})`}</h1>

              <ul className="d-flex align-items-center mom_filter">
                <li>
                  <ul className="nav nav-tabs" role="tablist">
                    <li>
                      <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                      >
                        <Tab eventKey="listView" title="List View"></Tab>
                        <Tab
                          eventKey="calendarView"
                          title="Calendar View"
                        ></Tab>
                      </Tabs>
                    </li>
                  </ul>
                </li>
                <li
                  className="d-flex align-items-center cursor-pointer"
                  onClick={() => setShowFilter(true)}
                >
                  Filter By{" "}
                  <img
                    src="/images/Sort.svg"
                    className="img-fluid ms-2"
                    alt="Sort"
                  />
                </li>
                <li>
                  <button
                    className="btn red_button d-flex align-items-center"
                    onClick={() => navigate("/admin/add-mom")}
                    disabled={!permissionscontext.add}
                  >
                    <FaPlus className="me-1" /> Add MoM
                  </button>
                </li>
              </ul>
            </div>

            <div className="tab-content ">
              {activeTab === "listView" && (
                <>
                <div className="todoList_table">
                  <div className="table-responsive">
                    <Table>
                      <thead className="table-dark">
                        <tr>
                          <th>Sr.No</th>
                          <th>Title</th>
                          <th>Date</th>
                          <th>Channel Partner</th>
                          <th>RM</th>
                          <th>Accomplished with</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      {momList && momList?.length > 0 ? (
                        <>
                          <tbody>
                            {momList.map((user, index) => (
                              <tr key={user.id}>
                                <td>{(currentPage - 1) * limit + index + 1}</td>
                                <td
                                // onClick={() =>
                                //   navigate(`/admin/mom-details/${user.id}`)
                                // }
                                >{capitalizeFirstLetter(user.agenda)}
                                </td>
                                <td>
                                  {`${formatDateDMY(
                                    user?.date
                                  )}`}
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <p className="textTransform">{user?.channel_partner_name}</p>
                                  </div>
                                </td>

                                <td className="textTransform">{`${user.relationship_manager_first_name} ${user.relationship_manager_last_name}`}</td>
                                <td className="textTransform">{user.accomplished_with ?? "N/A"}</td>

                                <td>
                                  <button
                                    disabled={!permissionscontext.view}
                                    style={{
                                      border: "none",
                                      background: "transparent",
                                      padding: 0,
                                      cursor: !permissionscontext.view
                                        ? "not-allowed"
                                        : "pointer",
                                      opacity: !permissionscontext.view
                                        ? 0.5
                                        : 1,
                                    }}
                                    onClick={() =>
                                      navigate(`/admin/mom-details/${user.id}`)
                                    }
                                  >
                                    <img
                                      src="/images/Eye.svg"
                                      className="img-fluid"
                                      alt="Eye.svg"
                                    />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </>
                      ) : (
                        <>
                          <tbody>
                            <tr>
                              <td colSpan="6" className="border-0">
                                <div className="d-flex align-items-center justify-content-center mt-5">
                                  <h4>Not Available</h4>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </>
                      )}
                    </Table>
                  </div>
                </div>
                <div className="position-relative misPage_footer ">
                   {activeTab === "listView" && count > 10 && (
                        <Paginator
                            currentPage={currentPage}
                            totalPages={totalCount}
                            onPageChange={handlePageChange}
                        />
                    )}
                    <button className="btn blue_border d-flex align-items-center"
                        onClick={handleDownload}
                        disabled={download}
                    ><RiDownloadCloudFill className="me-2" 
                    />{" "}
                    {download ? "Downloading..." : "Download"}
                    </button>
                </div>
                </>
              )}
              <div className="calender_scroll">
              {activeTab === "calendarView" && (
                <div className="calendar">
                  <div>{renderHeader()}</div>
                  <div>{renderDays()}</div>
                  <div>{renderCells()}</div>
                </div>
              )}
              </div>
            </div>
          </div>
          {showFilter && (
            <MomListFilter
              appliedFilters={filters}
              show={showFilter}
              onHide={() => setShowFilter(false)}
              onApplyFilter={(filterData) => {
                setFilters(filterData);
                setShowFilter(false);
              }}
              onClear={() => {
                setFilters({});
                setShowFilter(false);
                setSelectedRange("")
              }}
              setSelectedRange={setSelectedRange}
              selectedRange={selectedRange}
            />
          )}
        </>
      ) : (
        <Notauthorized />
      )}
    </>
  );
};

export default MomList;
